import { render, staticRenderFns } from "./AuditShow.vue?vue&type=template&id=2dd9c5da&scoped=true"
import script from "./AuditShow.vue?vue&type=script&lang=js"
export * from "./AuditShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd9c5da",
  null
  
)

export default component.exports